import React from 'react';
import PropTypes from 'prop-types';

const ArrowBack = props => {
  const { color, width, height, ...other } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" {...other}>
      <g id="arrow-back" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <polygon id="Shape" points="0 0 24 0 24 24 0 24"></polygon>
        <polygon id="Shape" fill={color} fillRule="nonzero" points="20 11 7.83 11 13.42 5.41 12 4 4 12 12 20 13.41 18.59 7.83 13 20 13"></polygon>
      </g>
    </svg>
  );
}

ArrowBack.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

ArrowBack.defaultProps = {
  color: '#000000',
  width: 24,
  height: 24,
};

export default ArrowBack;



// WEBPACK FOOTER //
// ./src/components/Icons/ArrowBack.jsx